var map = {
	"./al-quran.png": "e09e",
	"./batam-lokal.png": "c55a",
	"./bifood.png": "96c1",
	"./fms.png": "0506",
	"./lpk_bo.png": "ae4a",
	"./lpk_mobile.png": "a614",
	"./mccs_mobile.png": "c29a",
	"./mobis.png": "a797",
	"./mymovie.png": "3a51",
	"./nihonolive.png": "9f46",
	"./tire_ai.png": "3eb3",
	"./twotter.png": "946a",
	"./ultraGPT.png": "ea04"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c2d3";